import {gql} from "@apollo/client";

const QUERY_LIST=gql`
subscription entrances{
    clubmate_entrance_entrance(order_by:{datetime:desc}){
        id
        is_guest
        anonymous_check
        usersregister_userregister{
          id
          name
          surname
          fiscal_code
        }
        datetime
    }
}
`;

export {QUERY_LIST};